var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var superagent = require("superagent");
function request(data) {
    return superagent[data.method](data.url)
        .set(data.headers || {})
        .send(data.data || {})
        .query(data.query || {});
}
exports.request = request;
function getCSRF() {
    return __awaiter(this, void 0, void 0, function () {
        var response, errorMsg;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (window['__csrfPromise'])
                        return [2, window['__csrfPromise']];
                    return [4, request({
                            url: '/ajax/get-token/',
                            method: 'get',
                        })];
                case 1:
                    response = _a.sent();
                    try {
                        window['CSRF_TOKEN'] = JSON.parse(response.text).csrf;
                    }
                    catch (e) {
                        errorMsg = 'Error occured while loading. Please refresh the page.';
                        typeof defaultNotifier !== 'undefined'
                            ? defaultNotifier.push(errorMsg, 'error')
                            : console.error(errorMsg);
                    }
                    return [2, CSRF_TOKEN];
            }
        });
    });
}
exports.getCSRF = getCSRF;
function logEvent(inData, successCallback, failureCallback) {
    return __awaiter(this, void 0, void 0, function () {
        var data, headers, _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    inData = inData || {};
                    data = {
                        type: inData.type || window['sharedConstants']['logType']['view'],
                        ticket: inData.ticket || window['LOG_TICKET'],
                        page_id: inData.pageId || window['PAGE_ID'],
                        kind: inData.kind,
                        product: inData.product,
                        sub_kind: inData.sub_kind || inData.category,
                        marketing_params: inData.tparty,
                        referer: inData.referrer || document.referrer || undefined,
                        url: inData.url || window.location.href,
                        data: inData.data,
                    };
                    if (inData.kinds) {
                        data.kinds = inData.kinds;
                    }
                    if (data.type === window['sharedConstants']['logType']['submit']) {
                        data.mobile = inData.mobile;
                        data.email = inData.email;
                        data.name = inData.name;
                    }
                    _a = {
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest'
                    };
                    _b = 'X-CSRF-Token';
                    return [4, window['__csrfPromise']];
                case 1:
                    headers = (_a[_b] = _c.sent(),
                        _a);
                    if (data['mobile']) {
                        data['mobile'] = String(data['mobile']);
                    }
                    if (data.data && data.data.widget_name) {
                        data.data.widget_name = data.data.widget_name.replace(/-/g, '_');
                    }
                    return [2, request({
                            url: '/log-event/',
                            method: 'post',
                            data: data,
                            headers: headers,
                        })
                            .then(function (res) { return successCallback && successCallback(); })
                            .catch(function (err) {
                            var callback = failureCallback === true
                                ? successCallback
                                : failureCallback || successCallback;
                            callback && callback();
                        })];
            }
        });
    });
}
exports.logEvent = logEvent;
window['__csrfPromise'] = getCSRF();
window['sharedUtils'] = {
    request: request,
    logEvent: logEvent,
    getCSRF: getCSRF,
};
